import { isNumber } from 'lodash';
import type { OnyxCoordinates } from '../components/address-input/interfaces';

export const COORDINATES_PATTERN =
  /^\s*(?<latitude>-?\d+(?:[.,]\d+)?)\s*°?\s*(?:(?<latitudeMinutes>[0-5]?\d(?:[.,]\d+)?)\s*['′]\s*(?:(?<latitudeSeconds>[0-5]?\d(?:[.,]\d+)?)\s*(?:["″]|'')\s*)?)?(?<latitudeHemisphere>[NS])?(?:\s*[;,]\s*|\s+)(?<longitude>-?\d+(?:[.,]\d+)?)\s*°?\s*(?:(?<longitudeMinutes>[0-5]?\d(?:[.,]\d+)?)\s*['′]\s*(?:(?<longitudeSeconds>[0-5]?\d(?:[.,]\d+)?)\s*(?:["″]|'')\s*)?)?(?<longitudeHemisphere>[EW])?\s*$/i;

export class CoordinatesHelper {
  public static fromString(value: string): OnyxCoordinates | null {
    const match = value?.match(COORDINATES_PATTERN);
    if (!match) return null;

    const groups = match.groups!;
    const coordinates = {
      latitude: CoordinatesHelper.parseDegrees(groups, 'latitude', 'S'),
      longitude: CoordinatesHelper.parseDegrees(groups, 'longitude', 'W'),
    };

    return CoordinatesHelper.areValid(coordinates) ? coordinates : null;
  }

  public static toString(value: OnyxCoordinates | null | undefined): string {
    if (!isNumber(value?.latitude) || !isNumber(value?.longitude)) return '';
    return `${+value.latitude.toFixed(5)}, ${+value.longitude.toFixed(5)}`;
  }

  private static parseDegrees(
    groups: Record<string, string | undefined>,
    name: keyof OnyxCoordinates,
    negativeHemisphere: string,
  ): number {
    const [degrees, minutes, seconds] = [
      name,
      `${name}Minutes`,
      `${name}Seconds`,
    ].map((key) => parseFloat(groups[key]?.replace(',', '.') ?? '0'));
    const value = degrees + minutes / 60 + seconds / 3600;

    return groups[`${name}Hemisphere`]?.toUpperCase() === negativeHemisphere
      ? -value
      : value;
  }

  private static areValid(coordinates: OnyxCoordinates): boolean {
    return (
      coordinates.latitude >= -90 &&
      coordinates.latitude <= 90 &&
      coordinates.longitude >= -180 &&
      coordinates.longitude <= 180
    );
  }
}
